import { Badge } from "@/components/ui/badge"
import { statusBadgeVariant } from "@/lib/status"

export function Status({ children }: { children: string }) {
  return <Badge variant={statusBadgeVariant(children)}>{children}</Badge>
}
